module.exports = __webpack_public_path__ + "img/taca.ff444991.png";